import * as angular from "angular";
import {IController} from "angular";
import {FulfillmentStepModel} from "../../models/fulfillment-step.model";
import {FulfillmentAttemptModel} from "../../models/fulfillment-attempt.model";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";


export class FulfillmentStepsPodsImagesLinkComponent implements IController {

  fulfillmentSteps: FulfillmentStepModel[];
  onClick: Function;

  public numOfImages: number;


  constructor(private fulfillmentDialogService: FulfillmentDialogService) {
  }

  $onInit() {
    this.numOfImages = 0;
    if (this.fulfillmentSteps) {
      this.fulfillmentSteps.forEach((ffs) => {
        const activeAttempt = ffs.attempts?.find((a) => {
          return a.id === ffs.referenceId;
        })
        if (activeAttempt) {
          this.numOfImages += this._countAttachmentsWithBlobName(activeAttempt, true);
          this.numOfImages += this._countAttachmentsWithBlobName(activeAttempt, false);
        }
      })
    }
  }

  $onChanges(changes) {
    if (changes.fulfillmentSteps && !changes.fulfillmentSteps.isFirstChange()) {
      this.$onInit();
    }
  }

  private _countAttachmentsWithBlobName(attempt: FulfillmentAttemptModel, isPickup?: boolean): number {
    let imagesNum = 0;
    if (isPickup) {
      Object.entries(attempt?.serviceAttemptInfo?.pickupTaskInfo?.identifications || {}).forEach(([key, value], index) => {
        if (key.includes('BlobName')) {
          imagesNum++;
        }
      });
    } else {
      Object.entries(attempt?.serviceAttemptInfo?.destinationTaskInfo?.identifications || {}).forEach(([key, value], index) => {
        if (key.includes('BlobName')) {
          imagesNum++;
        }
      });

    }


    return imagesNum;
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsPodsImagesLink', {
    bindings: {
      fulfillmentSteps: '<?',
      onClick: '&?'
    },
    template: require('./fulfillment-steps-pods-images-link.html').default,
    controller: FulfillmentStepsPodsImagesLinkComponent
  });

